import angular from 'angular';

/* Module Imports */
import utilModule from '../utility/util.module';
import apiModule from '../api/api.module';

/* Directive Imports */
import AutofocusDirective from './autofocus.directive';
import ChildElementBlurDirective from './child-element-blur.directive';
import ConfirmOnExitDirective from './confirm-on-exit';
import DateGreaterThanDirective from './date-greater-than.directive';
import DateLowerThanDirective from './date-lower-than.directive';
import DateRangeGreaterThanDirective from './date-range-greater-than';
import DateRangeLowerThanDirective from './date-range-lower-than';
import FocusMeDirective from './focusMe.directive';
import iframeOnLoadDirective from './iframe-onload.directive';
import MissingFeaturesDirective from './missing-features';
import NgEnterDirective from './ng-enter.directive';
import ApplyClassDirective from './apply-class.directive';
import NumbersOnlyDirective from './numbers-only-input.directive';
import OpenSelectOnFocusDirective from './open-select-on-focus.directive';
import RequiresFeaturesDirectives from './requires-features.directive';
import SelectSetFocusOnDirective from './select-set-focus-on.directive';
import SetFocusOnDirective from './set-focus-on.directive';
import StopPropagationDirective from './stopPropagation.directive';
import StringToNumberDirective from './stringToNumber.directive';
import TagsSetFocusOnDirective from './tags-set-focus-on.directive';
import ValidFileDirective from './valid-file.directive';
import ExposeScopeDirective from './expose-scope.directive';
import ScrollDirective from './scroll.directive';
import PageSupportDirective from './pageSupport.directive';
import InfiniteLoadingDirective from './infinite-loading.directive';

const directivesModule = angular
  .module('app.directives', ['ui.bootstrap', 'ui.router', 'gettext', utilModule, apiModule])
  .directive('autofocus', AutofocusDirective)
  .directive('applyClass', ApplyClassDirective)
  .directive('childElementBlur', ChildElementBlurDirective)
  .directive('confirmOnExit', ConfirmOnExitDirective)
  .directive('dateGreaterThan', DateGreaterThanDirective)
  .directive('dateLowerThan', DateLowerThanDirective)
  .directive('dateRangeGreaterThan', DateRangeGreaterThanDirective)
  .directive('dateRangeLowerThan', DateRangeLowerThanDirective)
  .directive('focusMe', FocusMeDirective)
  .directive('iframeOnload', iframeOnLoadDirective)
  .directive('missingFeatures', MissingFeaturesDirective)
  .directive('ngEnter', NgEnterDirective)
  .directive('exposeScope', ExposeScopeDirective)
  .directive('numbersOnly', NumbersOnlyDirective)
  .directive('openSelectOnFocus', OpenSelectOnFocusDirective)
  .directive('requiresFeatures', RequiresFeaturesDirectives)
  .directive('selectSetFocusOn', SelectSetFocusOnDirective)
  .directive('setFocusOn', SetFocusOnDirective)
  .directive('stopPropagation', StopPropagationDirective)
  .directive('stringToNumber', StringToNumberDirective)
  .directive('tagsSetFocusOn', TagsSetFocusOnDirective)
  .directive('validFile', ValidFileDirective)
  .directive('scroll', ScrollDirective)
  .directive('pageSupport', PageSupportDirective)
  .directive('infiniteLoading', InfiniteLoadingDirective);

export default directivesModule.name;
